import { getScreenShots } from "@/services/screenshot-service";
import { ScreenShot } from "@/types/ScreenShotType";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import ms from "ms";

const useScreenShots = (gameId: string) => {
    return useQuery<ScreenShot[], Error>({
        queryKey: ['ScreenShots', gameId],
        queryFn: () => getScreenShots(gameId), // Pass a function reference
        placeholderData: keepPreviousData,
        staleTime: ms('24h')
    })
};

export default useScreenShots;
